// extracted by mini-css-extract-plugin
module.exports = {"popover":"Popover_popover__1nfiB","light":"Popover_light__xe2ed","dark":"Popover_dark__533oK"};